import React from "react";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";

const NONE = "__ingen__";

/**
 * Kategorivelger for husholdningsplanen.
 * - kind="utgift": hovedgrupper (COICOP) med undergrupper, hovedgruppen kan velges direkte.
 * - kind="inntekt": inntektskategoriene.
 * value: kategori-id eller null. onChange(id|null).
 */
export const CategoryPicker = ({ plan, kind = "utgift", value, onChange, placeholder = "Velg kategori", allowNone = true, noneLabel = "Ingen (bruk standard)", disabled, className, testId = "household-category-picker" }) => {
  const groups = kind === "inntekt" ? [{ id: "inntekt", code: "", name: "Inntekt", children: plan?.income || [] }] : plan?.groups || [];
  // Uten «ingen»-valg vises placeholder når verdi mangler (tom streng = placeholder-tilstand i Radix Select)
  const current = value || (allowNone ? NONE : "");
  return (
    <Select value={current} onValueChange={(v) => onChange(v === NONE ? null : v)} disabled={disabled}>
      <SelectTrigger className={cn("h-10", className)} data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent className="bg-card max-h-[360px]">
        {allowNone ? <SelectItem value={NONE} data-testid={`${testId}-none`}>{noneLabel}</SelectItem> : null}
        {groups.map((g) => (
          <SelectGroup key={g.id}>
            <SelectLabel className="flex items-center gap-2 text-xs uppercase tracking-wide text-muted-foreground"><span className="h-2 w-2 rounded-full" style={{ background: g.color || "#5B6776" }} />{g.code ? `${g.code} ` : ""}{g.name}</SelectLabel>
            {kind !== "inntekt" ? <SelectItem value={g.id} data-testid={`${testId}-opt-${g.code}`}><span className="font-medium">{g.code}</span> {g.name} <span className="text-muted-foreground">(hovedgruppe)</span></SelectItem> : null}
            {(g.children || []).map((c) => (
              <SelectItem key={c.id} value={c.id} data-testid={`${testId}-opt-${c.code}`}><span className={cn("font-medium tnum", kind !== "inntekt" && "pl-3")}>{c.code}</span> {c.name}</SelectItem>
            ))}
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
};

/** Liten kategori-brikke (kode + navn, farget prikk). */
export const CategoryChip = ({ code, name, color, muted, className, testId }) => (
  <span className={cn("inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs whitespace-nowrap max-w-full", muted ? "text-muted-foreground border-dashed" : "bg-card", className)} data-testid={testId}>
    <span className="h-2 w-2 rounded-full shrink-0" style={{ background: color || "#5B6776" }} />
    {code ? <span className="font-medium tnum">{code}</span> : null}
    <span className="truncate">{name || "Uten kategori"}</span>
  </span>
);
